<template>
  <div class="search-field">
    <label class="paragraph-s paragraph-dark-gray">{{ label }}</label>
    <b-field>
      <b-input
        :value="value"
        :placeholder="placeholder"
        class="search-input"
        ref="b-input"
        @input="onChangeSearch"
        @keyup.native.enter="onEnter"
        @blur="onSubmit"
      ></b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    initialValue: String,
  },
  data() {
    return {
      value: this.initialValue
    }
  },
  computed: {
    placeholder() {
      return ''
    },
    label() {
      return this.$gettext('Job title or keyword')
    }
  },
  methods: {
    onChangeSearch(value) {
      this.value = value.trim();
    },
    onEnter() {
      this.$refs['b-input'].$refs.input.blur();
    },
    onSubmit() {
      this.$emit('submit', this.value);
    }
  },
  name: "SearchField"
}
</script>

<style lang="scss" scoped>
.search-field .field, /deep/ .input {
  height: 36px;
}
</style>